<div echarts [options]="chartOptions" [merge]="chartUpdateOptions" theme="default" class="pool-history-chart"></div>
